
import { Component, Prop, Vue } from 'vue-property-decorator'
import { State } from 'xstate'

@Component
export default class StateMatches extends Vue {
  @Prop({ required: true })
  state!: State<any, any>

  get states() {
    return this.state.toStrings()
  }
}
